module.exports = __webpack_public_path__ + "img/edge.e700212b.jpg";